<span [transloco]="'COMMON.TASKS.' + task.category?.name"
      [translocoParams]="translationParams"></span>
